// Agrupacion de localStorage para DevTools (sin dependencias, probable).

export interface StorageGroup {
  prefix: string;
  keys: number;
  bytes: number;
}

/** Agrupa claves de localStorage por prefijo (hasta el primer `:` o `_` tras 3 letras). */
export function groupLocalStorage(entries: Array<[string, string]>): StorageGroup[] {
  const groups = new Map<string, StorageGroup>();
  for (const [key, value] of entries) {
    const match = /^(.{3,}?)[:_./]/.exec(key);
    const prefix = match ? match[1] : key;
    const g = groups.get(prefix) ?? { prefix, keys: 0, bytes: 0 };
    g.keys++;
    g.bytes += (key.length + value.length) * 2; // UTF-16
    groups.set(prefix, g);
  }
  return [...groups.values()].sort((a, b) => b.bytes - a.bytes);
}
